import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "list", "item" ]

  initialize() {

    this.index = 0;
    this.slides = 5;
    this.transform = 0;
    this.delay = 2000;

    this.next();

    // reset carousel on resize
    window.addEventListener("resize", () => {
      this.listTarget.removeAttribute("style");
      this.listTarget.classList.remove("animate");
      this.transform = 0;
      this.index = 0;
      this.delay = 0;
    });

  }

  next(delay) {
    setTimeout(() => {

      // last slide
      if(this.index === this.slides) {
        this.listTarget.classList.remove("animate");
        this.transform = 0;
        this.index = 0;
        this.delay = 0;
      // not last slide
      } else {
        this.listTarget.classList.add("animate");
        this.transform += this.itemTarget.clientWidth + 24;
        ++this.index;
        this.delay = 3000;
      }

      // apply transform
      this.listTarget.style.transform = "translate3d(-" + this.transform + "px, 0, 0)";

      // call function again with appropriate delay
      this.next(delay);

    }, this.delay);
  }

}
